import { BrowserRouter } from 'react-router-dom';
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { Toaster } from 'sonner';
// Use the shared provider
import { MuiThemeProvider } from "@shared";
import { LoaderProvider } from "@shared/Functions/LoaderContext";

// If you have Redux mode, you can read it and pass mode="dark"/"light".
// For now, keep it simple:
createRoot(document.getElementById("root")).render(
  <MuiThemeProvider brand="admin" mode="light">
    <BrowserRouter>
      <LoaderProvider>
        <App />
      </LoaderProvider>
      <Toaster
        position="top-right"
        closeButton
        duration={3000}
        richColors={false}
      />
    </BrowserRouter>
  </MuiThemeProvider>
);
